import 'flb-ui/dist/flb-ui.css'
import '../src/application.sass'
import 'flb-ui'
import { tooltip } from 'flb-ui'
import hljs from 'highlight.js'
import ClipboardJS from 'clipboard'

import Rails from '@rails/ujs'
Rails.start()
hljs.initHighlightingOnLoad()
window.hljs = hljs

document.addEventListener('DOMContentLoaded', function() {
  // Clipboard
  var clipboard = new ClipboardJS('.copy')

  clipboard.on('success', function(e) {
    tooltip(e.trigger, { trigger: 'manual', title: 'コピーしました' })
    tooltip(e.trigger, 'show')
    setTimeout(function() {
      tooltip(e.trigger, 'hide')
    }, 500)
  })

  clipboard.on('error', function(e) {
    tooltip(e.trigger, { trigger: 'manual', title: '失敗しました' })
    tooltip(e.trigger, 'show')
    setTimeout(function() {
      tooltip(e.trigger, 'hide')
    }, 500)
  })
})
